const ListNotificationPlaceholder = () => {
    return (
        <main className="flex flex-col gap-3">
            {[...new Array(6)].map((item, index) => {
                return (
                    <div
                        className="h-[5.375rem] animate-pulse rounded-md bg-icoGray-100 dark:bg-icoDarkMode-deepBlack"
                        key={index}
                    />
                );
            })}
        </main>
    );
};

export default ListNotificationPlaceholder;
